import * as Debug from 'debug';
import {AfterContentInit, AfterViewChecked, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {SearchService} from '../services/search_service';
import {StreamService} from '../services/stream_service';
import {NoteService} from '../services/note_service';
import {UserService} from '../services/user_service';

import {Note} from '../../shared/types/note';
import {User} from '../../shared/types/user';

import { Stream } from '../types/stream';
const debug = Debug('notd:RelatedNotesComponent');

@Component({
    selector: 'related-notes',
    templateUrl: './related-notes.component.html',
    styleUrls: ['./related-notes.component.scss']
})
export class RelatedNotesComponent implements AfterContentInit, OnChanges, OnInit {
    @Input() tags: string;
    @Input() rootNote: Note;

    notes: Note[] = [];
    isLoggedIn = false;
    profileId: any;
    myStreams: any;
    loading = false;
    empty = false;

    public userStreams: Stream[] = [];

    constructor(
        private searchService: SearchService,
        private streamService: StreamService,
        private noteService: NoteService,
        private userService: UserService,
        private route: ActivatedRoute,
        private router: Router
    ) { }

    ngOnInit() {
      debug('ngOnInit');

      this.isLoggedIn = this.userService.isLoggedIn();
      if (this.isLoggedIn) {
        this.getUserStreams();
      }

      if (this.isLoggedIn) {
        this.userService.getProfile()
            .then((user: User) => {
                this.profileId = user.id;
            });
      }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['tags']) {
            this.getNotes();
        }
    }

    ngAfterContentInit() {
      // this handler should be called last
      debug('AfterContentInit');
    }

    getNotes() {
        this.loading = true;
        this.notes = [];

        this.searchService.getRelatedNotes(this.rootNote.id).subscribe((result: any) => {
          const resNotes = result.posts || [];

          this.notes = this.route.params['value']['id'] ?
            resNotes.filter(n => n.id !== this.route.params['value']['id']).slice(0, 3) : resNotes.slice(0, 3);

          this.notes.map((note: Note) => {
            this.getStreamName(note);

            if (note.userId) {
              this.userService.getUserProfile(note.userId).then((user: User) => {
                note.user = user;
              }, err => {
                console.error('There was and issue while fetching user profile', err);
              });
            }
          });

          if (!this.notes || this.notes.length === 0) {
              this.loading = false;
              this.empty = true;
          }
        }, err => {
          console.error('Error while fetching related notes', err);
        });
    }

    getStreamName(note: any) {
      if (note.channelId) {
        this.streamService.getStreamInfoObservable(note.channelId).subscribe(result => {
          if (result) {
            Object.assign(note, {
              streamName: result.name
            });

            if (this.myStreams) {
              const myStream = this.myStreams.filter(s => s.id === note.channelId);
              note._ownned = (myStream.length > 0);
            }
          }
          this.loading = false;
        }, () => {
          console.log(`channel ${note.channelId} does not exist`);
        });
      }
    }

    private getUserStreams() {
      Promise.all([
        this.streamService.getUserStreams(),
        this.streamService.getUserTeamStreams()
      ]).then((results: any) => {
        const userStreams = results[0];
        const userTeamStreams = results[1].channels ? results[1].channels : [];

        this.userStreams = this.updateUserStreamsWithTeamStream(userStreams, userTeamStreams);

        if (this.userStreams.length) {
          // this.newNoteDisabled = false;
        }
      }, err => {
        console.error('Error while fetching user streams: ', err);
      });
    }

    private updateUserStreamsWithTeamStream(userStreams: Stream[], teamStreams: Stream[]): Stream[] {
      for (const ts of teamStreams) {
        if (!userStreams.filter(us => us.id === ts.id).length) {
          userStreams.push(ts);
        }
      }

      return userStreams;
    }
}
